export default "__VITE_ASSET__DcO10j8v__"